/**
 * 教材管理 API（双栈适配：Python FastAPI / Java Spring）
 */
import apiClient from '../client'
import {
  unwrapData,
  unwrapList,
  mapPythonTextbook,
  type TableDataInfo,
} from '../responseAdapter'
import { textbookApiPrefix } from './basePath'

export interface Textbook {
  textbookId: number
  title: string
  subject?: string
  version?: string
  status: string
  description?: string
  coverUrl?: string
  createBy?: string
  createTime?: string
  updateBy?: string
  updateTime?: string
  remark?: string
  /** Python SQL 列表字段 */
  name?: string
  tableName?: string
  educationLevel?: string
  category?: string
  id?: number | string
}

function prefix() {
  return textbookApiPrefix()
}

/** 查询教材列表（分页） */
export async function listTextbook(params?: {
  pageNum?: number
  pageSize?: number
  title?: string
  subject?: string
  status?: string
}): Promise<TableDataInfo<Textbook>> {
  const response = await apiClient.get(`${prefix()}/textbooks/list`, { params })
  const { rows, total } = unwrapList<Record<string, unknown>>(response)
  return {
    code: 200,
    msg: 'success',
    total,
    rows: rows.map((r) => mapPythonTextbook(r) as Textbook),
  }
}

/** 获取教材详情 */
export async function getTextbook(textbookId: number): Promise<{ data: Textbook }> {
  const response = await apiClient.get(`${prefix()}/textbooks/${textbookId}`)
  const raw = unwrapData<Record<string, unknown>>(response)
  return { data: mapPythonTextbook(raw) as Textbook }
}

/** 新增教材 */
export async function addTextbook(data: Partial<Textbook>) {
  return apiClient.post<{ code: number; msg: string }>(`${prefix()}/textbooks`, data)
}

/** 修改教材 */
export async function updateTextbook(data: Partial<Textbook> & { textbookId: number }) {
  const response = await apiClient.put(`${prefix()}/textbooks`, data)
  return unwrapData(response)
}

/** 删除教材 */
export async function delTextbook(textbookIds: number[] | string) {
  const ids = Array.isArray(textbookIds) ? textbookIds.join(',') : String(textbookIds)
  return apiClient.delete(`${prefix()}/textbooks/${ids}`)
}
